import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VuePageTransition from "vue-page-transition";
import VueTyperPlugin from "vue-typer";
import PreloaderAnimation from "@/components/PreloaderAnimation";
import { auth } from "./firebase-config";
import store from "./store";

//setting up an event bus to calculate the total number of links on each component view for the custom cursor to work
export const EventBus = new Vue();

Vue.use(VuePageTransition);
Vue.use(VueTyperPlugin);
Vue.component("PreloaderAnimation", PreloaderAnimation);

Vue.config.productionTip = false;
// handle page reloads
let app;
auth.onAuthStateChanged(user => {
  //fetch user
  if (user) {
    store.commit("setCurrentUser", user);
    store.dispatch("fetchUserProfile");
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
      mounted() {
        setTimeout(() => {
          document.dispatchEvent(new Event("render-event"));
        }, 5000);
      }
    }).$mount("#app");
  }

  //get total count of all images for pagination
  store.dispatch("images/countImages");
  //load first page of images
  if (store.state.images.images.length == 0) {
    store.dispatch("images/saveInitial");
  }

  if (store.state.websites.websites.length == 0) {
    store.dispatch("websites/saveInitial");
  }

  if (store.state.caseStudies.caseStudies.length == 0) {
    store.dispatch("caseStudies/saveInitial");
  }
});
